/** @file Whether a key event's target is a text-entry element, where shortcuts must stay silent. */

const TYPING_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/** True for input/textarea/select and contenteditable elements (duck-typed so it needs no DOM). */
export function isTypingTarget(target: unknown): boolean {
  if (typeof target !== 'object' || target === null) return false;
  const el = target as { tagName?: unknown; isContentEditable?: unknown };
  return (typeof el.tagName === 'string' && TYPING_TAGS.has(el.tagName.toUpperCase())) || el.isContentEditable === true;
}
